const { useCallback, useState } = require('react');

const classNames = require('classnames');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const { useI18n } = require('nordic/i18n');
const { Title } = require('@andes/typography');
const { Card, CardContent, CardFooter } = require('@andes/card');
const { List, ListItem } = require('@andes/list');

const stepActions = require('../../../spa/actions/step');
const { getQueryParams } = require('../../../utils/Dom');
const { STEP_NEXT } = require('../../../spa/actions/types');
const { DEVICE_TYPE } = require('../../../../constants/commons');
const translate = require('../../../translation');
const { ModalShippingAddress } = require('../Components/ModalShippingAddress');

const transformReusableAddress = ({
  zip_code,
  street_name,
  street_number,
  floor,
  city_name,
  state_name,
} = {}) => ({
  zipcode: zip_code,
  streetName: street_name,
  streetNumber: street_number,
  floor,
  cityName: city_name,
  stateName: state_name,
});

const getReusableAddressInfoForModal = ({ streetName, streetNumber, floor }) =>
  [streetName, streetNumber, floor].join(' ');

const ShippingAddressSelector = (props) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);
  const { flow, data, history, stepAction, deviceType } = props;

  const isMobile = deviceType === DEVICE_TYPE.MOBILE;
  const isDesktop = deviceType === DEVICE_TYPE.DESKTOP;

  const {
    address_list: addressList,
    address_step: addressStep,
    receiver_address,
    matched_address_id: matchedAddressId,
  } = data;
  const receiverAddress = transformReusableAddress(receiver_address);

  const [selectedAddressStep, setSelectedAddressStep] = useState(addressStep);

  const handleNextStep = useCallback(
    ({ id, addressStep }) => {
      const urlParams = getQueryParams();

      const defaultData = {
        urlParams,
        type: flow.type,
      };

      const payload = {
        isNewInterface: true,
        user_selection: id,
        address_step: addressStep,
      };

      stepAction[STEP_NEXT](
        payload,
        flow.id,
        defaultData,
        flow.type,
        urlParams,
        history,
      );
    },
    [flow, history],
  );

  const handleAddNewAddess = useCallback(() => {
    handleNextStep({ id: 'add_address', addressStep: 'choice_address' });
  }, []);

  const onReuseAddress = useCallback(() => {
    handleNextStep({
      id: matchedAddressId || 'add_address',
      addressStep: 'reused_address',
    });
  }, [matchedAddressId]);

  const onModifyAddress = useCallback(
    () => setSelectedAddressStep('choice_address'),
    [],
  );

  return (
    <section className="shipping-address-selector-v2 shipping-generics pb-24">
      <Title
        size={isMobile ? 'xs' : 's'}
        className={classNames('mt-40i mb-32i', { 'text-center': isMobile })}
        component="div"
      >
        {translations.SHIPPING_ADDRESS_SELECTOR_TITLE}
      </Title>

      <Card
        paddingSize={isMobile ? 24 : 32}
        shadow={isMobile ? 'elevated' : undefined}
        className="mb-32"
      >
        <CardContent className="d-flex d-flex-column g-32">
          <List
            id="address-selector"
            srLabel={translations.SHIPPING_ADDRESS_SELECTOR_TITLE}
            type="default"
            withDividers
            paddingSize={isMobile ? 24 : 32}
            className={classNames('address-selector-list', {
              desktop: isDesktop,
            })}
          >
            {addressList?.map(({ id, title, description }) => (
              <ListItem
                key={id}
                description={description}
                title={title}
                chevron
                className={classNames('item-list', { desktop: isDesktop })}
                onClick={() =>
                  handleNextStep({ id, addressStep: 'choice_address' })
                }
              />
            ))}
          </List>
        </CardContent>

        <CardFooter
          link={{
            onClick: handleAddNewAddess,
            title: translations.SHIPPING_ADDRESS_SELECTOR_ADD_NEW,
            text: translations.SHIPPING_ADDRESS_SELECTOR_ADD_NEW,
          }}
        />
      </Card>

      <ModalShippingAddress
        isOpen={selectedAddressStep}
        userType="logged"
        address={getReusableAddressInfoForModal(receiverAddress)}
        isMobile={isMobile}
        handleFirstAction={onReuseAddress}
        handleSecondaryAction={onModifyAddress}
      />
    </section>
  );
};

const mapStateToProps = (state) => ({
  flow: state.page.flow,
  configs: state.configurations,
});

const mapDispatchToProps = (dispatch) => ({
  stepAction: bindActionCreators(stepActions, dispatch),
});

module.exports = {
  ShippingAddressSelector: connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ShippingAddressSelector),
};
